function getFocusableElements(t) {
  return Array.from(
    t.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}
let isSddBannerClicked = false;
document.querySelectorAll('[id^="Details-"] summary').forEach((t) => {
  (t.setAttribute("role", "button"),
    t.setAttribute("aria-expanded", t.parentNode.hasAttribute("open")),
    t.nextElementSibling.getAttribute("id") &&
      t.setAttribute("aria-controls", t.nextElementSibling.id),
    (this.mql = window.matchMedia("(min-width: 990px)")),
    !mql.matches &&
      t.addEventListener("click", (t) => {
        if (
          t.currentTarget.id.startsWith("HeaderMenu-") &&
          !t.currentTarget.closest("details").hasAttribute("open")
        ) {
          let e = t.currentTarget.parentNode;
          for (; e && "UL" !== e.nodeName; ) e = e.parentNode;
          !(function t(e, i) {
            Array.from(e.children).forEach((e) => {
              ("DETAILS" === e.nodeName &&
                e !== i &&
                e.hasAttribute("open") &&
                (e.removeAttribute("open"), e.classList.remove("menu-opening")),
                t(e, i));
            });
          })(e, t.currentTarget.closest("details"));
        }
        t.currentTarget.setAttribute(
          "aria-expanded",
          !t.currentTarget.closest("details").hasAttribute("open"),
        );
      }),
    mql.matches &&
      t.addEventListener("mouseover", (t) => {
        if (
          t.currentTarget.id.startsWith("HeaderMenu-") &&
          !t.currentTarget.closest("details").hasAttribute("open")
        ) {
          t.currentTarget.closest("details").setAttribute("open", "");
          let e = t.currentTarget.parentNode;
          for (; e && "UL" !== e.nodeName; ) e = e.parentNode;
          (!(function t(e, i) {
            Array.from(e.children).forEach((e) => {
              ("DETAILS" === e.nodeName &&
                e !== i &&
                e.hasAttribute("open") &&
                (e.removeAttribute("open"), e.classList.remove("menu-opening")),
                t(e, i));
            });
          })(e, t.currentTarget.closest("details")),
            t.currentTarget.setAttribute(
              "aria-expanded",
              t.currentTarget.closest("details").hasAttribute("open"),
            ));
        }
      }),
    mql.matches &&
      t.addEventListener("mouseout", (t) => {
        t.currentTarget.id.startsWith("HeaderMenu-") &&
          t.currentTarget.closest("details").hasAttribute("open") &&
          !t.relatedTarget.closest("header-menu") &&
          (t.currentTarget
            .closest("header-menu")
            .querySelectorAll("details")[0]
            .removeAttribute("open"),
          t.currentTarget
            .closest("header-menu")
            .querySelectorAll("details")[0]
            .querySelectorAll("summary")[0]
            .setAttribute("aria-expanded", "false"));
      }),
    mql.matches &&
      t.nextElementSibling.addEventListener("mouseout", (t) => {
        t.currentTarget.id.startsWith("HeaderMenu-") &&
          !t.relatedTarget.closest("header-menu") &&
          (t.currentTarget
            .closest("header-menu")
            .querySelectorAll("details")[0]
            .removeAttribute("open"),
          t.currentTarget
            .closest("header-menu")
            .querySelectorAll("details")[0]
            .querySelectorAll("summary")[0]
            .setAttribute("aria-expanded", "false"));
      }),
    t.closest("header-drawer, menu-drawer") ||
      t.parentElement.addEventListener("keyup", onKeyUpEscape));
});
const trapFocusHandlers = {};
function trapFocus(t, e = t) {
  var i = getFocusableElements(t),
    s = i[0],
    n = i[i.length - 1];
  (removeTrapFocus(),
    (trapFocusHandlers.focusin = (e) => {
      (e.target !== t && e.target !== n && e.target !== s) ||
        document.addEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.focusout = function () {
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.keydown = function (e) {
      "TAB" === e.code.toUpperCase() &&
        (e.target !== n || e.shiftKey || (e.preventDefault(), s.focus()),
        (e.target !== t && e.target !== s) ||
          !e.shiftKey ||
          (e.preventDefault(), n.focus()));
    }),
    document.addEventListener("focusout", trapFocusHandlers.focusout),
    document.addEventListener("focusin", trapFocusHandlers.focusin),
    e && e.focus(),
    e &&
      "INPUT" === e.tagName &&
      ["search", "text", "email", "url"].includes(e.type) &&
      e.value &&
      e.setSelectionRange(0, e.value.length));
}
try {
  document.querySelector(":focus-visible");
} catch (t) {
  focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
  const t = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let e = null,
    i = null;
  (window.addEventListener("keydown", (e) => {
    t.includes(e.code.toUpperCase()) && (i = !1);
  }),
    window.addEventListener("mousedown", (t) => {
      i = !0;
    }),
    window.addEventListener(
      "focus",
      () => {
        (e && e.classList.remove("focused"),
          i || ((e = document.activeElement), e.classList.add("focused")));
      },
      !0,
    ));
}
function pauseAllMedia() {
  (document.querySelectorAll(".js-youtube").forEach((t) => {
    t.contentWindow.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}',
      "*",
    );
  }),
    document.querySelectorAll(".js-vimeo").forEach((t) => {
      t.contentWindow.postMessage('{"method":"pause"}', "*");
    }),
    document.querySelectorAll("video").forEach((t) => t.pause()),
    document.querySelectorAll("product-model").forEach((t) => {
      t.modelViewerUI && t.modelViewerUI.pause();
    }));
}
function removeTrapFocus(t = null) {
  (document.removeEventListener("focusin", trapFocusHandlers.focusin),
    document.removeEventListener("focusout", trapFocusHandlers.focusout),
    document.removeEventListener("keydown", trapFocusHandlers.keydown),
    t && t.focus());
}
function onKeyUpEscape(t) {
  if ("ESCAPE" !== t.code.toUpperCase()) return;
  const e = t.target.closest("details[open]");
  if (!e) return;
  const i = e.querySelector("summary");
  (e.removeAttribute("open"), i.setAttribute("aria-expanded", !1), i.focus());
}
document.querySelectorAll(".cust_del_address").forEach((t) => {
  if (
    localStorage.getItem("selectedDeliveryAddress") &&
    t
      .closest(".del-pincode-address-option")
      .querySelector(".cust_del_address_id") &&
    localStorage.getItem("selectedDeliveryAddress") ==
      t
        .closest(".del-pincode-address-option")
        .querySelector(".cust_del_address_id").value
  ) {
    document.querySelectorAll(".del-pincode-address-option").forEach((t) => {
      t.classList.remove("del-selected");
    });
    t.closest(".del-pincode-address-option").classList.add("del-selected");
    document.querySelector(".pincode_input").value = t.value;
    checkSameDayDelivery();
  }
  t.addEventListener("change", async (e) => {
    const i = e.target.closest(".del-pincode-address-option");
    if (i) {
      document.querySelectorAll(".del-pincode-address-option").forEach((t) => {
        t.classList.remove("del-selected");
      });
      i.classList.add("del-selected");
      document.querySelector(".pincode_input").value = e.target.value;
      localStorage.setItem(
        "selectedDeliveryAddress",
        i.querySelector(".cust_del_address_id").value,
      );
      localStorage.setItem("sddPincode", e.target.value);
      localStorage.setItem("sddUserId", __st.cid);
    }
  });
});
document
  .querySelector(".pincode_overlay .icon-close")
  .addEventListener("click", () => {
    document.querySelector(".pincode_overlay").style.display = "none";
    document.querySelector(".shopify-section-group-header-group").style.zIndex =
      4;
    isSddBannerClicked = false;
  });
document
  .querySelector(".pincode_overlay")
  .addEventListener("click", function (e) {
    const content = document.querySelector(".pincode_overlay_content");
    if (!content.contains(e.target)) {
      this.style.display = "none";
      document.querySelector(
        ".shopify-section-group-header-group",
      ).style.zIndex = 4;
      isSddBannerClicked = false;
    }
  });

function generateUUID() {
  if (window.crypto && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  const bytes = new Uint8Array(16);
  if (window.crypto && typeof crypto.getRandomValues === "function") {
    crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i++) {
      bytes[i] = Math.floor(Math.random() * 256);
    }
  }
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = [];
  for (let i = 0; i < bytes.length; i++) {
    hex.push(bytes[i].toString(16).padStart(2, "0"));
  }
  const value = hex.join("");
  return (
    value.slice(0, 8) +
    "-" +
    value.slice(8, 12) +
    "-" +
    value.slice(12, 16) +
    "-" +
    value.slice(16, 20) +
    "-" +
    value.slice(20)
  );
}
function getVisitorId() {
  let id = readCookie("visitor_id");
  if (!id) {
    id = generateUUID();
    writeSharedCookie("visitor_id", id, 30 * 24 * 60 * 60);
  }
  return id;
}

let sddPincode = "";
let showCustomCart = "true";
let showCustomPlp = "false";
let showCustomPdp = "false";
window.visitor_id = getVisitorId();

function listingPath(target) {
  return String(target || "").split("?")[0].replace(/^\//, "");
}
function plpIsCustom() {
  return showCustomPlp === "true" || window.plpMode === "custom";
}
function pdpIsCustom() {
  return showCustomPdp === "true" || window.pdpMode === "custom";
}
function isCustomProductTarget(target) {
  const path = listingPath(target);
  return path.indexOf("products/") === 0 && !/\.(js|json)$/.test(path);
}
function isCustomListingTarget(target) {
  const path = listingPath(target);
  return path === "search" || path.indexOf("collections/") === 0;
}
function redirectProductTarget(target) {
  if (!isCustomProductTarget(target)) return false;
  if (pdpIsCustom()) {
    window.location.replace(customListingUrl(target) + window.location.hash);
  } else {
    window.location.replace("/" + String(target).replace(/^\//, ""));
  }
  return true;
}
function customListingUrl(target) {
  const [path, existingQuery] = String(target || "").split("?");
  return `https://checkout.giva.co/${path}${existingQuery ? `?${existingQuery}` : ""}`;
}
function checkoutCollectionUrl(href) {
  if (!href) return null;
  let url;
  try {
    url = new URL(href, window.location.origin);
  } catch (err) {
    return null;
  }
  const host = url.hostname;
  const onStore =
    host === window.location.hostname ||
    host === "www.giva.co" ||
    host === "giva.co" ||
    host === "checkout.giva.co";
  const path = url.pathname;
  const isCollection = /^\/collections\/[^/]+/.test(path);
  const isProduct =
    /^\/products\/[^/]+/.test(path) &&
    !/\.(js|json)$/.test(path) &&
    !/(?:^|[?&])view=/.test(url.search);
  if (!onStore) return null;
  if (isProduct) {
    if (!pdpIsCustom()) return null;
  } else if (!isCollection || !plpIsCustom()) {
    return null;
  }
  if (host === "checkout.giva.co") return url.href;
  return "https://checkout.giva.co" + path + url.search + url.hash;
}
function rewriteCollectionAnchor(anchor) {
  const href = anchor.getAttribute("href");
  const destination = checkoutCollectionUrl(href);
  if (!destination || destination === href) return;
  if (!anchor.dataset.shopifyCollectionHref) {
    anchor.dataset.shopifyCollectionHref = href;
  }
  anchor.setAttribute("href", destination);
}
const CUSTOM_STOREFRONT_LINK_SELECTOR =
  'a[href*="/collections/"], a[href*="/products/"]';
function rewriteCollectionLinks(root) {
  const scope = root && root.querySelectorAll ? root : document;
  if (scope.matches && scope.matches(CUSTOM_STOREFRONT_LINK_SELECTOR)) {
    rewriteCollectionAnchor(scope);
  }
  scope.querySelectorAll(CUSTOM_STOREFRONT_LINK_SELECTOR).forEach(rewriteCollectionAnchor);
}
function watchCollectionLinks() {
  if (watchCollectionLinks.started || !document.body) return;
  watchCollectionLinks.started = true;
  new MutationObserver((mutations) => {
    if (!plpIsCustom() && !pdpIsCustom()) return;
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!node || node.nodeType !== 1) return;
        rewriteCollectionLinks(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
}
function isShopifyPreview() {
  if (window.givaIsShopifyPreview) return true;
  if (window.Shopify && Shopify.designMode) return true;
  try {
    if (/\.shopifypreview\.com$/i.test(window.location.hostname)) return true;
    const params = new URLSearchParams(window.location.search);
    return params.has("preview_key") || params.has("preview_theme_id");
  } catch (err) {
    return false;
  }
}
let collectionLinksReady = null;
function prepareCustomCollectionLinks() {
  if (isShopifyPreview()) return Promise.resolve(false);
  if (!collectionLinksReady) {
    collectionLinksReady = (async () => {
      try {
        const refId = await generateCustomCartRefId();
        if (!refId) {
          collectionLinksReady = null;
          return false;
        }
        rewriteCollectionLinks(document);
        watchCollectionLinks();
        return true;
      } catch (err) {
        collectionLinksReady = null;
        return false;
      }
    })();
  }
  return collectionLinksReady;
}
function hasValidRefAccessCookie() {
  return refSessionIsValid(readRefSession());
}
document.addEventListener(
  "click",
  (event) => {
    if (!plpIsCustom() && !pdpIsCustom()) return;
    if (isShopifyPreview()) return;
    if (event.button !== 0) return;
    const anchor = event.target && event.target.closest ? event.target.closest("a[href]") : null;
    if (!anchor) return;
    const destination = checkoutCollectionUrl(anchor.getAttribute("href"));
    if (!destination) return;
    const newTab =
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      anchor.target === "_blank";
    if (hasValidRefAccessCookie()) {
      if (!anchor.dataset.shopifyCollectionHref) {
        anchor.dataset.shopifyCollectionHref = anchor.getAttribute("href");
      }
      anchor.setAttribute("href", destination);
      return;
    }
    event.preventDefault();
    prepareCustomCollectionLinks().then((ready) => {
      if (!ready) {
        const fallback = anchor.dataset.shopifyCollectionHref;
        if (fallback && !newTab) window.location.href = fallback;
        return;
      }
      if (newTab) {
        const opened = window.open(destination, "_blank", "noopener");
        if (!opened) window.location.href = destination;
      } else {
        window.location.href = destination;
      }
    });
  },
  true,
);
async function redirectToCustomCollectionOrSearch() {
  if (typeof customPageTarget === "undefined" || !customPageTarget) return false;
  if (isShopifyPreview()) return false;
  const productPage = typeof customPageKind !== "undefined" && customPageKind === "pdp";
  if (productPage ? !pdpIsCustom() : !plpIsCustom()) return false;
  let refId = null;
  try {
    refId = await generateCustomCartRefId();
  } catch (err) {
    return false;
  }
  if (!refId) return false;
  const search = window.location.search.replace(/^\?/, "");
  const target = search ? `${customPageTarget}?${search}` : customPageTarget;
  window.location.replace(customListingUrl(target) + window.location.hash);
  return true;
}
function applyPlpMode() {
  const custom = showCustomPlp === "true";
  window.plpMode = custom ? "custom" : "shopify";
  window.dispatchEvent(
    new CustomEvent("plpmode:ready", { detail: window.plpMode }),
  );
}
function applyPdpMode() {
  const custom = showCustomPdp === "true";
  window.pdpMode = custom ? "custom" : "shopify";
  window.dispatchEvent(
    new CustomEvent("pdpmode:ready", { detail: window.pdpMode }),
  );
}
function settleAfterStorefrontRedirect() {
  const productPage = typeof customPageKind !== "undefined" && customPageKind === "pdp";
  const hasTarget = typeof customPageTarget !== "undefined" && !!customPageTarget;
  const thisPageCustom = productPage ? pdpIsCustom() : plpIsCustom();
  if (isShopifyPreview() || (!plpIsCustom() && !pdpIsCustom())) {
    window.settleShopifyListing?.(true);
    return;
  }
  prepareCustomCollectionLinks().then(async (ready) => {
    if (!hasTarget || !thisPageCustom) {
      window.settleShopifyListing?.(true);
      return;
    }
    const redirecting = ready && (await redirectToCustomCollectionOrSearch());
    window.settleShopifyListing?.(!redirecting);
  });
}
window.applyPlpMode = applyPlpMode;
window.applyPdpMode = applyPdpMode;

document.addEventListener("DOMContentLoaded", async () => {
  document.querySelectorAll(".header_pincode_box").forEach((t) => {
    t.addEventListener("click", (e) => {
      firePincodeClickEvent();
      document.querySelector(".pincode_overlay").style.display = "flex";
      document.querySelector(
        ".shopify-section-group-header-group",
      ).style.zIndex = 1;
    });
  });
  const pincodeInput = document.querySelector(".pincode_input");
  const pincodeSubmitButton = document.querySelector(".pincode_submit_button");
  if (
    __st.cid &&
    localStorage.getItem("sddUserId") &&
    localStorage.getItem("sddUserId") == __st.cid
  ) {
    if (localStorage.getItem("sddPincode")) {
      document.querySelector(".pincode_input").value =
        localStorage.getItem("sddPincode");
    } else {
      document.querySelector(".pincode_input").value = custZip || "";
    }
  }
  function togglePincodeButton() {
    if (pincodeInput.value.trim().length === 0) {
      pincodeSubmitButton.setAttribute("disabled", "disabled");
    } else {
      pincodeSubmitButton.removeAttribute("disabled");
    }
  }
  pincodeInput.addEventListener("input", togglePincodeButton);
  togglePincodeButton();
  const cartPincodeFromStorage = localStorage.getItem("cartPincode");
  if (cartPincodeFromStorage && cartPincodeFromStorage.trim().length > 0) {
    sddPincode = cartPincodeFromStorage;
    localStorage.setItem("sddPincode", sddPincode);
  } else if (document.getElementById("pincode_input").value.trim().length > 0) {
    sddPincode = document.getElementById("pincode_input").value;
  } else {
    sddPincode = localStorage.getItem("sddPincode");
  }
  if (sddPincode && sddPincode.length > 0) {
    document.getElementById("pincode_input").value = sddPincode;
    checkSameDayDelivery({
      preferCart: !!(
        cartPincodeFromStorage && cartPincodeFromStorage.trim().length > 0
      ),
    });
  } else {
    // if (
    //   (window.location.pathname === "/" ||
    //     window.location.href.includes("collections")) &&
    //   !sessionStorage.getItem("pincodeAsked")
    // ) {
    //   document.querySelector(".pincode_overlay").style.display = "flex";
    //   document.querySelector(
    //     ".shopify-section-group-header-group",
    //   ).style.zIndex = 1;
    //   sessionStorage.setItem("pincodeAsked", true);
    // }
    let sddBanner = document.querySelector(".banner-sdd-box");
    let sddBannerSlide = document.querySelectorAll(".sdd-banner-slide");
    if (sddBanner) {
      window.sddBannerClickHandler = function (e) {
        e.preventDefault();
        document.querySelector(".pincode_overlay").style.display = "flex";
        document.querySelector(
          ".shopify-section-group-header-group",
        ).style.zIndex = 1;
        isSddBannerClicked = true;
      };
      sddBanner.addEventListener("click", window.sddBannerClickHandler);
    }
    if (sddBannerSlide.length > 0) {
      sddBannerSlide.forEach((banner) => {
        if (!banner._sddBannerSlideClickHandler) {
          banner._sddBannerSlideClickHandler = function (e) {
            e.preventDefault();
            document.querySelector(".pincode_overlay").style.display = "flex";
            document.querySelector(
              ".shopify-section-group-header-group",
            ).style.zIndex = 1;
            isSddBannerClicked = true;
          };
          banner.addEventListener("click", banner._sddBannerSlideClickHandler);
        }
      });
    }
  }

  // Cart, PLP, and PDP modes come from GET /api/cart/config. They are independent.
  const now = Date.now();
  let showCustomCartFromStorage = localStorage.getItem("showCustomCart");
  let showCustomPlpFromStorage = localStorage.getItem("showCustomPlp");
  let showCustomPdpFromStorage = localStorage.getItem("showCustomPdp");
  let userIdFromStorage = localStorage.getItem("showCustomCartUserId");
  let showCustomCartExpiry = parseInt(
    localStorage.getItem("showCustomCartExpiry"),
    10,
  );
  const cartModeCached =
    showCustomCartFromStorage === "true" || showCustomCartFromStorage === "false";
  const plpModeCached =
    showCustomPlpFromStorage === "true" || showCustomPlpFromStorage === "false";
  const pdpModeCached =
    showCustomPdpFromStorage === "true" || showCustomPdpFromStorage === "false";
  let customer_id;
  if (
    !cartModeCached ||
    !plpModeCached ||
    !pdpModeCached ||
    !showCustomCartExpiry ||
    !userIdFromStorage ||
    now > showCustomCartExpiry ||
    (__st.cid && userIdFromStorage != __st.cid)
  ) {
    document.documentElement.classList.add("cart-mode-pending");
    document.querySelectorAll("product-form").forEach((form) => {
      if (typeof form.lockForCartMode === "function") form.lockForCartMode();
    });
    if (localStorage.getItem("showCustomCart") !== "false") {
      fetchCustomCartOnce();
    }
    try {
      if (__st.cid) {
        customer_id = __st.cid;
      } else {
        customer_id = await window.visitor_id;
      }
      const refId = await waitForCustomCartRefId();
      if (!refId) throw new Error("Missing ref access token");
      const response = await fetch(
        "https://prod-bifrost.giva-api.com/api/cart/config",
        {
          headers: { ref_access_token: refId },
        },
      );
      const resdata = await response.json();
      if (!response.ok || !resdata.success || !resdata.data) {
        throw new Error(resdata.message || "Config request failed");
      }
      // Custom cart only: the config's cart `mode` is ignored.
      // `plp_mode` covers collection and search. `pdp_mode` covers product pages.
      showCustomCart = "true";
      showCustomPlp = resdata.data.plp_mode === "custom" ? "true" : "false";
      showCustomPdp = resdata.data.pdp_mode === "custom" ? "true" : "false";
      localStorage.setItem("showCustomCart", showCustomCart);
      localStorage.setItem("showCustomPlp", showCustomPlp);
      localStorage.setItem("showCustomPdp", showCustomPdp);
      localStorage.setItem(
        "showCustomCartExpiry",
        (now + 24 * 60 * 60 * 1000).toString(),
      );
      localStorage.setItem("showCustomCartUserId", customer_id);
      setCustomCartElements();
      if (typeof window.resolveCartMode === "function") {
        window.resolveCartMode(showCustomCart);
      }
      applyPlpMode();
      applyPdpMode();
      settleAfterStorefrontRedirect();
    } catch (err) {
      showCustomCart = "true";
      showCustomPlp = "false";
      showCustomPdp = "false";
      setCustomCartElements();
      if (typeof window.resolveCartMode === "function") {
        window.resolveCartMode(showCustomCart);
      }
      applyPlpMode();
      applyPdpMode();
      settleAfterStorefrontRedirect();
    }
  } else {
    showCustomCart = "true";
    showCustomPlp = showCustomPlpFromStorage;
    showCustomPdp = showCustomPdpFromStorage;
    setCustomCartElements();
    if (typeof window.resolveCartMode === "function") {
      window.resolveCartMode(showCustomCart);
    }
    applyPlpMode();
    applyPdpMode();
    settleAfterStorefrontRedirect();
  }
});
async function setCartItemCount() {
  try {
    let data = await fetchCustomCartOnce();
    let count = 0;
    if (data && data.data) {
      customCartId = data.data.cart.id;
      if (customCartId.length === 0) {
        customCartId = undefined;
      }
      if (data.data.cart?.shipping_address?.zip?.length > 0) {
        localStorage.setItem("cartPincode", data.data.cart.shipping_address.zip);
        checkSameDayDelivery({ preferCart: true });
      } else {
        localStorage.removeItem("cartPincode");
      }
      if (data.data.cart.items.length > 0) {
        count = data.data.cart.items
          .filter((item) => item.item_id != "31471233106010")
          .map((item) => item.quantity)
          .reduce((a, b) => a + b, 0);
      }
    } else {
      localStorage.removeItem("cartPincode");
    }
    document.querySelectorAll(".header__icon--cart").forEach((el) => {
      if (el.getAttribute("id") == "cart-icon-bubble") {
        el.querySelector(".cart-count-bubble").removeAttribute("style");
        el.querySelector(".cart-count-bubble")
          .querySelectorAll("span")
          .forEach((span) => {
            span.innerHTML = count;
          });
      }
    });
  } finally {
    document.querySelectorAll("#cart-icon-bubble .cart-count-bubble").forEach((bubble) => {
      bubble.removeAttribute("style");
    });
  }
}
let cartHomePromise = null;
let cartCountPromise = null;
function fetchCustomCartOnce() {
  if (!cartHomePromise) cartHomePromise = fetchCustomCart();
  return cartHomePromise;
}
function whenCartCountReady() {
  if (localStorage.getItem("showCustomCart") === "false") return Promise.resolve();
  if (!cartCountPromise) {
    cartCountPromise = setCartItemCount().catch((err) => {
      console.error(err);
    });
  }
  return cartCountPromise;
}
window.whenCartCountReady = whenCartCountReady;
if (localStorage.getItem("showCustomCart") === "true") {
  fetchCustomCartOnce();
}
let customCartRefIdWaiter = null;
function setCustomCartButtonBusy(btn, busy) {
  if (!btn) return;
  if (busy) {
    btn.classList.add("loading");
    const spinner = btn.querySelector(".loading-overlay__spinner");
    if (spinner) spinner.classList.remove("hidden");
  } else {
    btn.classList.remove("loading");
    const spinner = btn.querySelector(".loading-overlay__spinner");
    if (spinner) spinner.classList.add("hidden");
  }
}
async function waitForShowCustomCartFlag() {
  while (!localStorage.getItem("showCustomCart")) {
    await new Promise((resolve) => setTimeout(resolve, 100));
  }
  return localStorage.getItem("showCustomCart");
}
async function waitForCustomCartRefId() {
  if (!customCartRefIdWaiter) {
    customCartRefIdWaiter = generateCustomCartRefId()
      .then((refId) => {
        if (!refId) customCartRefIdWaiter = null;
        return refId;
      })
      .catch((err) => {
        customCartRefIdWaiter = null;
        throw err;
      });
  }
  return customCartRefIdWaiter;
}
window.setCustomCartButtonBusy = setCustomCartButtonBusy;
window.waitForCustomCartRefId = waitForCustomCartRefId;
window.waitForShowCustomCartFlag = waitForShowCustomCartFlag;
async function openCustomCartPage() {
  const existing = readRefSession();
  let refId = refSessionIsValid(existing) ? existing.token : null;
  if (!refId) {
    refId =
      typeof waitForCustomCartRefId === "function"
        ? await waitForCustomCartRefId()
        : await generateCustomCartRefId();
  }
  if (!refId) return;
  let sessionId = null;
  try {
    sessionId = await Promise.race([
      Promise.resolve(window.visitor_id).catch(() => null),
      new Promise((resolve) => setTimeout(() => resolve(null), 300)),
    ]);
  } catch (err) {
    sessionId = null;
  }
  const userId = window.__st && window.__st.cid ? window.__st.cid : null;
  const params = new URLSearchParams(window.location.search);
  const gclid = params.get("gclid");
  const fbclid = params.get("fbclid");
  window.location.href = `https://checkout.giva.co/cart?ref_id=${latestRefAccessToken(refId)}&${userId ? `user_id=${userId}&` : ""}${sessionId ? `session_id=${sessionId}&` : ""}${gclid ? `gclid=${gclid}&` : ""}${fbclid ? `fbclid=${fbclid}&` : ""}`;
}
window.openCustomCartPage = openCustomCartPage;
function goldHarvestCheckoutPath(pathname) {
  const match = String(pathname || "").match(
    /^(?:\/pages)?(\/gold-harvest(?:\/[^?#]*)?)\/?$/,
  );
  if (!match) return null;
  let path = match[1].replace(/\/$/, "");
  if (path === "/gold-harvest") path = "/gold-harvest/new";
  return path;
}
function goldHarvestCheckoutUrl(href, refId) {
  let path = null;
  let params = new URLSearchParams();
  if (!href) {
    path = "/gold-harvest/new";
  } else {
    try {
      const url = new URL(href, window.location.origin);
      path = goldHarvestCheckoutPath(url.pathname);
      if (!path) return null;
      params = new URLSearchParams(url.search);
    } catch (e) {
      return null;
    }
  }
  params.set("ref_id", refId);
  return `https://checkout.giva.co${path}?${params.toString()}`;
}
function pointGoldHarvestLinksAtCheckout(refId) {
  const links = new Set([
    ...document.querySelectorAll(".ghs-page-link"),
    ...document.querySelectorAll("a[href*='/gold-harvest']"),
  ]);
  links.forEach((el) => {
    const next = goldHarvestCheckoutUrl(el.getAttribute("href"), refId);
    if (!next) return;
    el.setAttribute("href", next);
    if (el.classList.contains("ghs-page-link")) el.removeAttribute("style");
  });
}
async function setCustomCartElements() {
  if (showCustomCart == "true") {
    document.querySelectorAll(".header__icon--account-link").forEach((el) => {
      el.setAttribute(
        "href",
        `https://www.giva.co/account/login?return_url=/?loggedInUser=1`,
      );
    });
    let refId = await waitForCustomCartRefId();
    pointGoldHarvestLinksAtCheckout(refId);
    document.querySelectorAll(".bottom-metal-toggle-bar a").forEach((el) => {
      if (el.getAttribute("href") == "/account") {
        el.setAttribute(
          "href",
          `https://www.giva.co/account/login?return_url=/?loggedInUser=1`,
        );
      }
    });
    if (
      window.location.pathname === "/account" &&
      document.querySelector(".custom-flow")
    ) {
      document.querySelector(".custom-flow").removeAttribute("style");
      document.querySelector("#reco-loader").style.display = "none";
    }
    whenCartCountReady();
    document.querySelectorAll(".header__icon--cart").forEach((el) => {
      if (el.getAttribute("id") == "cart-icon-bubble") {
        el.addEventListener("click", async (e) => {
          e.preventDefault();
          try {
            const href = e.currentTarget.getAttribute("href");
            const readyRefId = refId || (await waitForCustomCartRefId());
            if (!readyRefId) return;
            if (!href.split("?ref_id=")[1]) {
              let userIdForCart = __st.cid ? __st.cid : null;
              let sessionIdForCart = await window.visitor_id;
              let gclid =
                new URLSearchParams(window.location.search).get("gclid") ||
                null;
              let fbclid =
                new URLSearchParams(window.location.search).get("fbclid") ||
                null;
              let customCartUrl = `https://checkout.giva.co/cart?ref_id=${latestRefAccessToken(readyRefId)}&${userIdForCart ? `user_id=${userIdForCart}&` : ""}${sessionIdForCart ? `session_id=${sessionIdForCart}&` : ""}${gclid ? `gclid=${gclid}&` : ""}${fbclid ? `fbclid=${fbclid}&` : ""}`;
              document.querySelectorAll(".header__icon--cart").forEach((el) => {
                if (el.getAttribute("id") == "cart-icon-bubble") {
                  el.setAttribute("href", customCartUrl);
                }
              });
              window.location.href = customCartUrl;
            } else {
              window.location.href = href;
            }
          } catch (err) {
            console.error(err);
          }
        });
        el.removeAttribute("style");
      }
    });
    if (
      window.location.pathname === "/cart" ||
      window.location.pathname === "/cart/"
    ) {
      if (!refId) return;
      let userIdForCart = __st.cid ? __st.cid : null;
      let sessionIdForCart = await window.visitor_id;
      let gclid =
        new URLSearchParams(window.location.search).get("gclid") || null;
      let fbclid =
        new URLSearchParams(window.location.search).get("fbclid") || null;
      let customCartUrl = `https://checkout.giva.co/cart?ref_id=${latestRefAccessToken(refId)}&${userIdForCart ? `user_id=${userIdForCart}&` : ""}${sessionIdForCart ? `session_id=${sessionIdForCart}&` : ""}${gclid ? `gclid=${gclid}&` : ""}${fbclid ? `fbclid=${fbclid}&` : ""}`;
      window.location.replace(customCartUrl);
    }
  } else {
    document.querySelectorAll(".header__icon--cart").forEach((el) => {
      if (el.getAttribute("id") == "cart-icon-bubble") {
        el.removeAttribute("style");
        el.querySelector("#cart-count-bubble").removeAttribute("style");
      }
    });
    let refId = await generateRefId();
    pointGoldHarvestLinksAtCheckout(refId);
    if (
      window.location.pathname === "/account" &&
      document.querySelector(".normal-flow")
    ) {
      document.querySelector(".normal-flow").removeAttribute("style");
      document.querySelector("#reco-loader").style.display = "none";
    }
  }
}
document
  .querySelector(".pincode_submit_button")
  .addEventListener("click", (e) => {
    if (
      document.querySelector(".del-selected") &&
      document.querySelector(".pincode_input").value !=
        document.querySelector(".del-selected .cust_del_address").value
    ) {
      localStorage.removeItem("selectedDeliveryAddress");
      localStorage.setItem(
        "sddPincode",
        document.querySelector(".pincode_input").value,
      );
      document.querySelectorAll(".del-pincode-address-option").forEach((t) => {
        t.classList.remove("del-selected");
      });
    }
    firePincodeEnterEvent(document.querySelector(".pincode_input").value);
    e.target.innerHTML = "Updating...";
    e.target.setAttribute("disabled", "disabled");
    checkSameDayDelivery();
    document.querySelector(".banner-sdd-box") &&
      document
        .querySelector(".banner-sdd-box")
        .removeEventListener("click", window.sddBannerClickHandler);
    document.querySelectorAll(".sdd-banner-slide").forEach((banner) => {
      banner.removeEventListener("click", banner._sddBannerSlideClickHandler);
    });
  });
async function generateRefId() {
  clearStoredKeys(LEGACY_REF_STORAGE_KEYS);
  const currUtmSource = localStorage.getItem("utm_source");
  const currUtmMedium = localStorage.getItem("utm_medium");
  let payload = {
    user_shopify_id: null,
    user_email: null,
    visitor_id: await window.visitor_id,
    metadata: {
      utm_source: currUtmSource,
      utm_medium: currUtmMedium,
    },
  };
  const currentUser = __st.cid ? String(__st.cid) : "non loggedin user";
  const stored = readLegacyRefSession();
  const storedExp = stored ? tokenExpiryMs(stored.token) : 0;
  const utmChanged =
    !stored ||
    (currUtmSource || "") !== (stored.utm_source || "") ||
    (currUtmMedium || "") !== (stored.utm_medium || "");
  let refId = stored && stored.token;
  if (!refId || !storedExp || Date.now() > storedExp || stored.user !== currentUser || utmChanged) {
    refId = null;
    if (__st.cid) {
      await fetch(
        `/apps/sdd-proxy?visitor_id=${payload.visitor_id}&metadata=${encodeURIComponent(JSON.stringify(payload.metadata))}`,
      )
        .then((res) => res.json())
        .then((data) => {
          refId = data.data;
        });
    } else {
      await fetch("https://api.givadiva.co/v2/features/mto/mtoWebTemp", {
        method: "POST",
        body: JSON.stringify(payload),
        headers: { "Content-Type": "application/json" },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          refId = data.data;
        });
    }
    if (!refId) return null;
    writeLegacyRefSession({
      token: refId,
      user: currentUser,
      utm_source: currUtmSource || "",
      utm_medium: currUtmMedium || "",
    });
  }
  return refId;
}
function parseStoredValue(value) {
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch {
    return value; // plain string like "google"
  }
}
const REF_ACCESS_COOKIE = "ref_access_object";
const LEGACY_REF_COOKIE = "ref_id_object";
const GUEST_REF_USER = "non loggedin user";
const CUSTOM_REF_STORAGE_KEYS = [
  "CUSTOM_REF_ID_KEY",
  "CUSTOM_REF_ID_EXPIRY_KEY",
  "CUSTOM_REF_ID_USER",
  "CUSTOM_REF_ID_UTM_SOURCE",
  "CUSTOM_REF_ID_UTM_MEDIUM",
];
const LEGACY_REF_STORAGE_KEYS = [
  "REF_ID_KEY",
  "REF_ID_USER",
  "REF_ID_EXPIRY_KEY",
  "REF_ID_UTM_SOURCE",
  "REF_ID_UTM_MEDIUM",
];
function sharedCookieDomainAttribute() {
  const host = window.location.hostname;
  if (host === "giva.co" || host.endsWith(".giva.co")) return "; Domain=.giva.co";
  return "";
}
function readCookie(name) {
  const key = `${name}=`;
  const parts = document.cookie ? document.cookie.split("; ") : [];
  for (let i = 0; i < parts.length; i++) {
    if (parts[i].indexOf(key) === 0) {
      const raw = parts[i].slice(key.length);
      try {
        return decodeURIComponent(raw);
      } catch (err) {
        return raw;
      }
    }
  }
  return "";
}
function writeSharedCookie(name, value, maxAgeSeconds) {
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${name}=${encodeURIComponent(value)}${sharedCookieDomainAttribute()}; Path=/; Max-Age=${Math.max(1, maxAgeSeconds)}; SameSite=Lax${secure}`;
}
function clearStoredKeys(keys) {
  keys.forEach((key) => localStorage.removeItem(key));
}
function decodeRefIdJwt(token) {
  if (!token || token.split(".").length !== 3) return null;
  try {
    const segment = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = segment + "=".repeat((4 - (segment.length % 4)) % 4);
    return JSON.parse(atob(padded));
  } catch (err) {
    return null;
  }
}
function tokenExpiryMs(token) {
  const claims = decodeRefIdJwt(token);
  return claims && claims.exp ? claims.exp * 1000 : 0;
}
function currentRefUser() {
  return window.__st && window.__st.cid
    ? String(window.__st.cid)
    : GUEST_REF_USER;
}
function currentUtmPair() {
  return {
    utm_source: localStorage.getItem("utm_source") || "",
    utm_medium: localStorage.getItem("utm_medium") || "",
  };
}
function utmComparable(value) {
  if (value == null || value === "") return "";
  if (typeof value === "object" && value.value != null) return String(value.value);
  if (typeof value !== "string") return String(value);
  const parsed = parseStoredValue(value);
  if (parsed && typeof parsed === "object" && parsed.value != null) {
    return String(parsed.value);
  }
  return parsed == null ? "" : String(parsed);
}
function refSessionIsValid(session) {
  if (!session || !session.token) return false;
  const jwtExpMs = tokenExpiryMs(session.token);
  if (!jwtExpMs || Date.now() > jwtExpMs) return false;
  if ((session.user || GUEST_REF_USER) !== currentRefUser()) return false;
  const utm = currentUtmPair();
  if (session.compareParsedUtm) {
    return (
      utmComparable(session.utm_source) === utmComparable(utm.utm_source) &&
      utmComparable(session.utm_medium) === utmComparable(utm.utm_medium)
    );
  }
  return (
    (session.utm_source || "") === utm.utm_source &&
    (session.utm_medium || "") === utm.utm_medium
  );
}
function sessionFromRawToken(token) {
  const claims = decodeRefIdJwt(token);
  if (!claims) return null;
  const payload = claims.payload || {};
  const metadata = payload.metadata || {};
  const userClaim = payload.user_shopify_id || payload.user_id || "";
  return {
    token,
    user: userClaim ? String(userClaim) : GUEST_REF_USER,
    utm_source: metadata.utm_source != null ? metadata.utm_source : "",
    utm_medium: metadata.utm_medium != null ? metadata.utm_medium : "",
    compareParsedUtm: true,
  };
}
function readRefSession() {
  const raw = readCookie(REF_ACCESS_COOKIE);
  if (!raw) return null;
  if (raw.charAt(0) === "{") {
    try {
      const data = JSON.parse(raw);
      if (!data || !data.token) return null;
      return {
        token: data.token,
        user: data.user || GUEST_REF_USER,
        utm_source: data.utm_source || "",
        utm_medium: data.utm_medium || "",
        compareParsedUtm: false,
      };
    } catch (err) {
      return null;
    }
  }
  return sessionFromRawToken(raw);
}
function persistRefAccessCookie(session) {
  const exp = tokenExpiryMs(session.token);
  const maxAgeSeconds = Math.floor((exp - Date.now()) / 1000);
  if (!session.token || maxAgeSeconds <= 0) return false;
  clearStoredKeys(CUSTOM_REF_STORAGE_KEYS);
  if (session.compareParsedUtm) {
    writeSharedCookie(REF_ACCESS_COOKIE, session.token, maxAgeSeconds);
    return true;
  }
  writeSharedCookie(
    REF_ACCESS_COOKIE,
    JSON.stringify({
      token: session.token,
      exp,
      user: session.user,
      utm_source: session.utm_source || "",
      utm_medium: session.utm_medium || "",
    }),
    maxAgeSeconds,
  );
  return true;
}
function readLegacyRefSession() {
  const raw = readCookie(LEGACY_REF_COOKIE);
  if (!raw) return null;
  try {
    const data = JSON.parse(raw);
    if (!data || !data.token) return null;
    return {
      token: data.token,
      user: data.user || GUEST_REF_USER,
      utm_source: data.utm_source || "",
      utm_medium: data.utm_medium || "",
    };
  } catch (err) {
    return null;
  }
}
function writeLegacyRefSession(session) {
  const maxAgeSeconds = Math.floor((tokenExpiryMs(session.token) - Date.now()) / 1000);
  if (maxAgeSeconds <= 0) return;
  writeSharedCookie(
    LEGACY_REF_COOKIE,
    JSON.stringify({
      token: session.token,
      user: session.user,
      utm_source: session.utm_source || "",
      utm_medium: session.utm_medium || "",
    }),
    maxAgeSeconds,
  );
}
async function generateCustomCartRefId() {
  clearStoredKeys(CUSTOM_REF_STORAGE_KEYS);
  const existing = readRefSession();
  if (refSessionIsValid(existing)) return existing.token;

  const currUtmSource = localStorage.getItem("utm_source");
  const currUtmMedium = localStorage.getItem("utm_medium");
  const currentUser = currentRefUser();
  const payload = {
    user_shopify_id: null,
    user_email: null,
    visitor_id: await window.visitor_id,
    metadata: {
      ...(currUtmSource != null && {
        utm_source: parseStoredValue(currUtmSource),
      }),
      ...(currUtmMedium != null && { utm_medium: currUtmMedium }),
      marketing:
        (window.dataLayer || []).find((item) => item.marketing)?.marketing ||
        {},
    },
  };
  const params = new URLSearchParams({
    visitor_id: String(payload.visitor_id),
    metadata: JSON.stringify(payload.metadata), // URLSearchParams encodes this
  });
  let refId = null;
  if (window.__st && window.__st.cid) {
    await fetch(`/apps/custom-cart-proxy?${params.toString()}`)
      .then((res) => res.json())
      .then((data) => {
        refId = data.data;
      });
  } else {
    await fetch(
      `https://prod-bifrost.giva-api.com/api/user/visitor-token?${params.toString()}`,
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        refId = data.data;
      });
  }
  if (!refId) return null;
  persistRefAccessCookie({
    token: refId,
    user: currentUser,
    utm_source: currUtmSource || "",
    utm_medium: currUtmMedium || "",
  });
  return refId;
}
const BIFROST_TOKEN_RETRIES = 3;
let refTokenRefresh = null;
function clearSharedCookie(name) {
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${name}=${sharedCookieDomainAttribute()}; Path=/; Max-Age=0; SameSite=Lax${secure}`;
}
function latestRefAccessToken(fallback) {
  const session = readRefSession();
  return (session && session.token) || fallback || "";
}
window.latestRefAccessToken = latestRefAccessToken;
function bifrostRequestUrl(input) {
  if (typeof input === "string") return input;
  if (typeof URL !== "undefined" && input instanceof URL) return input.href;
  if (input && typeof input.url === "string") return input.url;
  return "";
}
function requestRefToken(input, init) {
  try {
    const headers = new Headers((init && init.headers) || undefined);
    const fromInit = headers.get("ref_access_token");
    if (fromInit) return fromInit;
    if (typeof Request !== "undefined" && input instanceof Request) {
      return input.headers.get("ref_access_token") || "";
    }
  } catch (err) {}
  return "";
}
function isAuthedBifrostRequest(input, init) {
  const url = bifrostRequestUrl(input);
  if (url.indexOf("bifrost.giva-api.com") === -1) return false;
  if (url.indexOf("/api/user/visitor-token") !== -1) return false;
  return !!requestRefToken(input, init);
}
function tokenErrorInPayload(data) {
  if (!data || typeof data !== "object") return false;
  const codes = [data.status, data.statusCode, data.code];
  const messages = [data.message, data.error, data.description, data.msg];
  if (data.data && typeof data.data === "object") {
    codes.push(data.data.status, data.data.statusCode, data.data.code);
    messages.push(data.data.message, data.data.error, data.data.description);
  }
  if (codes.some((code) => code === 401 || code === "401")) return true;
  return messages.some((value) => {
    if (typeof value !== "string") return false;
    return /invalid token|token invalid|expired token|token expired|token has expired|jwt expired|jwt invalid|invalid jwt|expired jwt/i.test(
      value,
    );
  });
}
async function responseIndicatesBadToken(response) {
  if (response.status === 401) return true;
  try {
    return tokenErrorInPayload(await response.clone().json());
  } catch (err) {
    return false;
  }
}
function withRefToken(input, init, token) {
  const headers = new Headers(
    (init && init.headers) ||
      (typeof Request !== "undefined" && input instanceof Request
        ? input.headers
        : undefined),
  );
  headers.set("ref_access_token", token);
  return Object.assign({}, init, { headers });
}
async function refreshRefAccessToken() {
  if (!refTokenRefresh) {
    clearSharedCookie(REF_ACCESS_COOKIE);
    customCartRefIdWaiter = null;
    refTokenRefresh = generateCustomCartRefId()
      .catch(() => null)
      .finally(() => {
        refTokenRefresh = null;
      });
    customCartRefIdWaiter = refTokenRefresh.then((refId) => {
      if (!refId) customCartRefIdWaiter = null;
      return refId;
    });
  }
  return refTokenRefresh;
}
function installBifrostTokenRetry() {
  if (window.fetch && window.fetch.__bifrostTokenRetry) return;
  const nativeFetch = window.fetch.bind(window);
  async function bifrostFetch(input, init) {
    if (!isAuthedBifrostRequest(input, init)) {
      return nativeFetch(input, init);
    }
    const reusable =
      typeof Request !== "undefined" && input instanceof Request
        ? input.clone()
        : input;
    let response = await nativeFetch(input, init);
    for (let attempt = 0; attempt < BIFROST_TOKEN_RETRIES; attempt++) {
      if (!(await responseIndicatesBadToken(response))) return response;
      const token = await refreshRefAccessToken();
      if (!token) return response;
      const nextInput =
        typeof Request !== "undefined" && reusable instanceof Request
          ? reusable.clone()
          : reusable;
      response = await nativeFetch(nextInput, withRefToken(reusable, init, token));
    }
    return response;
  }
  bifrostFetch.__bifrostTokenRetry = true;
  window.fetch = bifrostFetch;
}
installBifrostTokenRetry();
async function notifyLogin(redirect, cartId = null) {
  let refId = await generateCustomCartRefId();
  const target =
    new URLSearchParams(window.location.search).get("target") || "cart";
  fetch(`https://prod-bifrost.giva-api.com/api/cart/notify-login`, {
    method: "POST",
    body: JSON.stringify({ cart_id: cartId }),
    headers: {
      "Content-Type": "application/json",
      ref_access_token: refId,
    },
  })
    .then((response) => response.json())
    .then(async (data) => {
      document.querySelectorAll(".header__icon--cart").forEach((el) => {
        if (el.getAttribute("id") == "cart-icon-bubble") {
          const bubble = el.querySelector(".cart-count-bubble");
          if (!bubble) return;
          bubble.removeAttribute("style");
          bubble.querySelectorAll("span").forEach((span) => {
            if (data.data && data.data.cart && data.data.cart.items) {
              span.innerHTML = data.data.cart.items
                .map((item) => item.quantity)
                .reduce((a, b) => a + b, 0);
            }
          });
        }
      });
      if (redirect) {
        if (redirectProductTarget(target)) return;
        if (isCustomListingTarget(target)) {
          if (!refId) return;
          window.location.replace(
            customListingUrl(target) + window.location.hash,
          );
          return;
        }
        if (target !== "cart") {
          window.location.replace(
            `https://checkout.giva.co/${target}?ref_id=${latestRefAccessToken(refId)}`,
          );
          return;
        }
        let userIdForCart = __st.cid ? __st.cid : null;
        let sessionIdForCart = await window.visitor_id;
        let gclid =
          new URLSearchParams(window.location.search).get("gclid") || null;
        let fbclid =
          new URLSearchParams(window.location.search).get("fbclid") || null;
        let respCartId = data?.data?.cart?.id || null;
        let customCartUrl = `https://checkout.giva.co/cart?ref_id=${latestRefAccessToken(refId)}${respCartId ? `&cart_id=${respCartId}` : ""}&${userIdForCart ? `user_id=${userIdForCart}&` : ""}${sessionIdForCart ? `session_id=${sessionIdForCart}&` : ""}${gclid ? `gclid=${gclid}&` : ""}${fbclid ? `fbclid=${fbclid}&` : ""}`;
        window.location.replace(customCartUrl);
      }
    })
    .catch((error) => {
      console.error("Error:", error);
      if (redirect) {
        if (redirectProductTarget(target)) return;
        if (isCustomListingTarget(target)) {
          if (!refId) return;
          window.location.replace(
            customListingUrl(target) + window.location.hash,
          );
        } else if (target !== "cart" && refId) {
          window.location.replace(
            `https://checkout.giva.co/${target}?ref_id=${latestRefAccessToken(refId)}`,
          );
        } else {
          window.location.href = "/";
        }
      }
    });
}
const baseUrl = window.location.origin + window.location.pathname;
if (baseUrl === "https://www.giva.co/pages/redirecting") {
  (async () => {
    if (showCustomCart == "true") {
      let cartId =
        new URLSearchParams(window.location.search).get("cart_id") || null;
      notifyLogin(true, cartId);
    } else {
      let refId = await generateRefId();
      let target =
        new URLSearchParams(window.location.search).get("target") || null;
      if (target) {
        if (redirectProductTarget(target)) return;
        if (isCustomListingTarget(target)) {
          const listingRefId = await generateCustomCartRefId();
          if (!listingRefId) return;
          window.location.replace(
            customListingUrl(target) + window.location.hash,
          );
        } else {
          let customCartUrl = `https://checkout.giva.co/${target}?ref_id=${latestRefAccessToken(refId)}`;
          window.location.replace(customCartUrl);
        }
      }
    }
  })();
}
(async function redirectGoldHarvestPage() {
  const targetPath = goldHarvestCheckoutPath(window.location.pathname);
  if (!targetPath) return;
  const refId =
    showCustomCart == "true"
      ? await waitForCustomCartRefId()
      : await generateRefId();
  if (!refId) return;
  const params = new URLSearchParams(window.location.search);
  params.set("ref_id", refId);
  window.location.replace(
    `https://checkout.giva.co${targetPath}?${params.toString()}`,
  );
})();
const loginUrlParams = new URLSearchParams(window.location.search);
if (loginUrlParams.get("loggedInUser") == "1") {
  notifyLogin(false);
}
async function checkSameDayDelivery(options = {}) {
  const { preferCart = false } = options;
  const pincodeInputEl = document.querySelector(".pincode_input");
  const inputPincode = pincodeInputEl ? pincodeInputEl.value.trim() : "";
  const cartPincode = localStorage.getItem("cartPincode") || "";
  const storedSddPincode = localStorage.getItem("sddPincode") || "";

  sddPincode = preferCart
    ? cartPincode || inputPincode || storedSddPincode
    : inputPincode || cartPincode || storedSddPincode;

  if (!sddPincode) {
    document.querySelector(".pincode_submit_button").innerHTML = "Update";
    document
      .querySelector(".pincode_submit_button")
      .removeAttribute("disabled");
    return;
  }

  if (pincodeInputEl) {
    pincodeInputEl.value = sddPincode;
  }

  localStorage.setItem("sddPincode", sddPincode);
  if (!preferCart && cartPincode !== sddPincode) {
    localStorage.setItem("cartPincode", sddPincode);
  }

  setTimeout(async () => {
    let refId = await generateRefId();
    getSddScreen({ data: refId });
  }, 2000);
  if (!preferCart) {
    updateCustomCartAddress(sddPincode);
  }
}
let customCartId;
async function updateCustomCartAddress(pincode) {
  if (showCustomCart == "true" && customCartId) {
    let refId = await generateCustomCartRefId();
    let address = {};
    address.zip = pincode;
    let selectedAddr = document.querySelector(".del-selected");
    if (selectedAddr) {
      address.line1 = selectedAddr.querySelector("#customer_addr_line1").value;
      address.line2 = selectedAddr.querySelector("#customer_addr_line2").value;
      address.city = selectedAddr.querySelector("#customer_addr_city").value;
      address.state = selectedAddr.querySelector("#customer_addr_state").value;
      address.country = selectedAddr.querySelector(
        "#customer_addr_country",
      ).value;
    }
    fetch("https://prod-bifrost.giva-api.com/api/cart/update", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ref_access_token: refId,
      },
      body: JSON.stringify({
        cart_id: customCartId,
        user_id: __st.cid || (await window.visitor_id),
        entity_type: "fulfillment",
        shipping_address: address,
        billing_address: address,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Cart address update response:", data);
      });
  }
}
async function fetchCustomCart() {
  let refId = await waitForCustomCartRefId();
  if (!refId) return null;
  let resp = await fetch(`https://prod-bifrost.giva-api.com/api/cart/home`, {
    headers: { ref_access_token: refId },
    cache: "no-store",
  });
  if (!resp.ok) {
    console.log("No cart found for user");
  } else {
    const data = await resp.json();
    if (data.data) {
      customCartId = data.data.cart.id;
      if (customCartId.length === 0) {
        customCartId = undefined;
      }
    }
    return data;
  }
  return resp;
}
async function getSddScreen(data) {
  if (data.data && data.data.length > 0) {
    const refId = data.data;
    const now = new Date();
    const days = now.getHours() < 13 ? 0 : 1;
    await fetch(
      `https://api.givadiva.co/apps/productScreen/checkDeliveryEstimations?days=${days}&pincode=${sddPincode}`,
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.data === true) {
          localStorage.setItem("sddAvailable", "true");
          if (typeof checkTransitions === "function") {
            checkTransitions();
          }
        } else {
          localStorage.setItem("sddAvailable", "false");
          document.querySelectorAll(".sdd_text_box").forEach((el) => {
            el.style.display = "none";
          });
        }
        let sddBanner = document.querySelector(".banner-sdd-box");
        let sddBannerSlide = document.querySelectorAll(".sdd-banner-slide");
        if (data.data && data.data === true) {
          const sddUrl = `https://express.giva.co/?ref_id=${refId}&pincode=${sddPincode}`;
          if (sddBanner) {
            Array.from(sddBanner.querySelectorAll(".sdd-banner-link")).forEach(
              (a) => {
                a.setAttribute("href", sddUrl);
              },
            );
          }
          if (sddBannerSlide.length > 0) {
            sddBannerSlide.forEach((banner) => {
              Array.from(banner.getElementsByTagName("a")).forEach((a) => {
                a.setAttribute("href", sddUrl);
              });
            });
          }
          if (document.querySelector("#sdd-fast-delivery-logo")) {
            document.querySelector("#sdd-fast-delivery-logo").style.display =
              "block";
          }
          if (document.querySelector("#sdd-location-logo")) {
            document.querySelector("#sdd-location-logo").style.display = "none";
          }
          if (document.querySelector("#no-sdd-logo")) {
            document.querySelector("#no-sdd-logo").style.display = "none";
          }
          if (document.querySelector("#update-del-text")) {
            document.querySelector("#update-del-text").innerHTML =
              `Fast Delivery to <strong>${sddPincode}</strong>`;
          }
          if (isSddBannerClicked) {
            window.location.href = sddUrl;
          }
        } else {
          if (document.querySelector("#update-del-text")) {
            document.querySelector("#update-del-text").innerHTML =
              `Deliver to <strong>${sddPincode}</strong>`;
          }
          if (document.querySelector("#no-sdd-logo")) {
            document.querySelector("#no-sdd-logo").style.display = "block";
          }
          if (document.querySelector("#sdd-fast-delivery-logo")) {
            document.querySelector("#sdd-fast-delivery-logo").style.display =
              "none";
          }
          if (document.querySelector("#sdd-location-logo")) {
            document.querySelector("#sdd-location-logo").style.display = "none";
          }
          if (sddBanner) {
            Array.from(sddBanner.querySelectorAll(".sdd-banner-link")).forEach(
              (a) => {
                a.setAttribute(
                  "href",
                  "https://www.giva.co/collections/bestsellers",
                );
              },
            );
          }
          if (sddBannerSlide.length > 0) {
            sddBannerSlide.forEach((banner) => {
              Array.from(banner.getElementsByTagName("a")).forEach((a) => {
                a.setAttribute(
                  "href",
                  "https://www.giva.co/collections/bestsellers",
                );
              });
            });
          }
        }
        isSddBannerClicked = false;
        document.querySelector(".pincode_overlay").style.display = "none";
      });
  }
  document.querySelector(".pincode_submit_button").innerHTML = "Update";
  document.querySelector(".pincode_submit_button").removeAttribute("disabled");
}
class QuantityInput extends HTMLElement {
  constructor() {
    (super(),
      (this.input = this.querySelector("input")),
      (this.changeEvent = new Event("change", { bubbles: !0 })),
      this.input.addEventListener("change", this.onInputChange.bind(this)),
      this.querySelectorAll("button").forEach((t) =>
        t.addEventListener("click", this.onButtonClick.bind(this)),
      ));
  }
  quantityUpdateUnsubscriber = void 0;
  connectedCallback() {
    (this.validateQtyRules(),
      (this.quantityUpdateUnsubscriber = subscribe(
        PUB_SUB_EVENTS.quantityUpdate,
        this.validateQtyRules.bind(this),
      )));
  }
  disconnectedCallback() {
    this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber();
  }
  onInputChange(t) {
    this.validateQtyRules();
  }
  onButtonClick(t) {
    t.preventDefault();
    const e = this.input.value;
    ("plus" === t.target.name ? this.input.stepUp() : this.input.stepDown(),
      e !== this.input.value && this.input.dispatchEvent(this.changeEvent));
  }
  validateQtyRules() {
    const t = parseInt(this.input.value);
    if (this.input.min) {
      const e = parseInt(this.input.min);
      this.querySelector(".quantity__button[name='minus']").classList.toggle(
        "disabled",
        t <= e,
      );
    }
    if (this.input.max) {
      const e = parseInt(this.input.max);
      this.querySelector(".quantity__button[name='plus']").classList.toggle(
        "disabled",
        t >= e,
      );
    }
  }
}
function debounce(t, e) {
  let i;
  return (...s) => {
    (clearTimeout(i), (i = setTimeout(() => t.apply(this, s), e)));
  };
}
function throttle(t, e) {
  let i = 0;
  return function (...s) {
    const n = new Date().getTime();
    if (!(n - i < e)) return ((i = n), t(...s));
  };
}
function fetchConfig(t = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/" + t },
  };
}
(customElements.define("quantity-input", QuantityInput),
  void 0 === window.Shopify && (window.Shopify = {}),
  (Shopify.bind = function (t, e) {
    return function () {
      return t.apply(e, arguments);
    };
  }),
  (Shopify.setSelectorByValue = function (t, e) {
    for (var i = 0, s = t.options.length; i < s; i++) {
      var n = t.options[i];
      if (e == n.value || e == n.innerHTML) return ((t.selectedIndex = i), i);
    }
  }),
  (Shopify.addListener = function (t, e, i) {
    t.addEventListener
      ? t.addEventListener(e, i, !1)
      : t.attachEvent("on" + e, i);
  }),
  (Shopify.postLink = function (t, e) {
    var i = (e = e || {}).method || "post",
      s = e.parameters || {},
      n = document.createElement("form");
    for (var r in (n.setAttribute("method", i),
    n.setAttribute("action", t),
    s)) {
      var o = document.createElement("input");
      (o.setAttribute("type", "hidden"),
        o.setAttribute("name", r),
        o.setAttribute("value", s[r]),
        n.appendChild(o));
    }
    (document.body.appendChild(n), n.submit(), document.body.removeChild(n));
  }),
  (Shopify.CountryProvinceSelector = function (t, e, i) {
    ((this.countryEl = document.getElementById(t)),
      (this.provinceEl = document.getElementById(e)),
      (this.provinceContainer = document.getElementById(i.hideElement || e)),
      Shopify.addListener(
        this.countryEl,
        "change",
        Shopify.bind(this.countryHandler, this),
      ),
      this.initCountry(),
      this.initProvince());
  }),
  (Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
      var t = this.countryEl.getAttribute("data-default");
      (Shopify.setSelectorByValue(this.countryEl, t), this.countryHandler());
    },
    initProvince: function () {
      var t = this.provinceEl.getAttribute("data-default");
      t &&
        this.provinceEl.options.length > 0 &&
        Shopify.setSelectorByValue(this.provinceEl, t);
    },
    countryHandler: function (t) {
      var e = (n =
          this.countryEl.options[this.countryEl.selectedIndex]).getAttribute(
          "data-provinces",
        ),
        i = JSON.parse(e);
      if ((this.clearOptions(this.provinceEl), i && 0 == i.length))
        this.provinceContainer.style.display = "none";
      else {
        for (var s = 0; s < i.length; s++) {
          var n;
          (((n = document.createElement("option")).value = i[s][0]),
            (n.innerHTML = i[s][1]),
            this.provinceEl.appendChild(n));
        }
        this.provinceContainer.style.display = "";
      }
    },
    clearOptions: function (t) {
      for (; t.firstChild; ) t.removeChild(t.firstChild);
    },
    setOptions: function (t, e) {
      var i = 0;
      for (e.length; i < e.length; i++) {
        var s = document.createElement("option");
        ((s.value = e[i]), (s.innerHTML = e[i]), t.appendChild(s));
      }
    },
  }));
class MenuDrawer extends HTMLElement {
  constructor() {
    (super(),
      (this.mainDetailsToggle = this.querySelector("details")),
      this.addEventListener("keyup", this.onKeyUp.bind(this)),
      this.addEventListener("focusout", this.onFocusOut.bind(this)),
      this.bindEvents());
    if (this.querySelectorAll(".search-mobile-sort-by").length > 0) {
      this.handleMobileSort();
    }
  }
  bindEvents() {
    (this.querySelectorAll("summary").forEach((t) =>
      t.addEventListener("click", this.onSummaryClick.bind(this)),
    ),
      this.querySelectorAll("button:not(.localization-selector)").forEach((t) =>
        t.addEventListener("click", this.onCloseButtonClick.bind(this)),
      ));
    if (this.querySelector("#close-filter")) {
      this.querySelector("#close-filter").addEventListener(
        "click",
        this.closeMenuDrawer.bind(this),
      );
    }
  }
  handleMobileSort() {
    this.querySelector(".select").addEventListener("click", () => {
      document.querySelector(
        "#retail_search_mob_sort_by_overlay",
      ).style.display = "flex";
    });
    document
      .querySelector("#retail_search_close-sort-by")
      .addEventListener("click", () => {
        document.querySelector(
          "#retail_search_mob_sort_by_overlay",
        ).style.display = "none";
      });
  }
  onKeyUp(t) {
    if ("ESCAPE" !== t.code.toUpperCase()) return;
    const e = t.target.closest("details[open]");
    e &&
      (e === this.mainDetailsToggle
        ? this.closeMenuDrawer(
            t,
            this.mainDetailsToggle.querySelector("summary"),
          )
        : this.closeSubmenu(e));
  }
  closeChildren(t, e) {
    Array.from(t.children).forEach((t) => {
      ("DETAILS" === t.nodeName &&
        t !== e &&
        t.hasAttribute("open") &&
        (t.removeAttribute("open"), t.classList.remove("menu-opening")),
        this.closeChildren(t, e));
    });
  }
  onSummaryClick(t) {
    const e = t.currentTarget,
      i = e.parentNode,
      s = i.closest(".has-submenu"),
      n = i.hasAttribute("open"),
      r = window.matchMedia("(prefers-reduced-motion: reduce)");
    // Menu-drawer submenu items should only ever open, never close again on
    // a repeat click of an already-open summary — block the browser's
    // native <details> toggle-off. The main drawer toggle (the hamburger
    // icon itself) is unaffected, since its own open/close is handled
    // separately below.
    if (i !== this.mainDetailsToggle && n) {
      t.preventDefault();
      return;
    }
    function o() {
      (trapFocus(e.nextElementSibling, i.querySelector("button")),
        e.nextElementSibling.removeEventListener("transitionend", o));
    }
    let a = i;
    for (; a && "UL" !== a.nodeName; ) a = a.parentNode;
    (a && this.closeChildren(a, i),
      i === this.mainDetailsToggle
        ? (n && t.preventDefault(),
          n ? this.closeMenuDrawer(t, e) : this.openMenuDrawer(e),
          window.matchMedia("(max-width: 990px)") &&
            document.documentElement.style.setProperty(
              "--viewport-height",
              window.innerHeight + "px",
            ))
        : setTimeout(() => {
            if (
              Array.from(e.classList).includes("focus-inset") &&
              Array.from(e.classList).includes("mobile-facets__summary") &&
              window.matchMedia("(max-width: 990px)").matches
            ) {
              this.querySelectorAll("summary").forEach((el) => {
                if (Array.from(el.classList).includes("focus-inset")) {
                  el.parentNode.classList.remove("menu-opening");
                  el.parentNode.removeAttribute("open");
                  el.setAttribute("aria-expanded", "false");
                }
              });
              (i.classList.add("menu-opening"),
                i.setAttribute("open", ""),
                e.setAttribute("aria-expanded", "true"),
                s && s.classList.add("submenu-open"),
                !r || r.matches
                  ? o()
                  : e.nextElementSibling.addEventListener("transitionend", o));
            } else {
              (i.classList.add("menu-opening"),
                e.setAttribute("aria-expanded", !0),
                s && s.classList.add("submenu-open"),
                !r || r.matches
                  ? o()
                  : e.nextElementSibling.addEventListener("transitionend", o));
            }
          }, 100));
  }
  openMenuDrawer(t) {
    document.getElementsByTagName("sticky-header")[0].style.display = "none";
    document.getElementsByClassName("haptik-icon")[0].style.zIndex = 1;
    document.getElementsByClassName("utility-bar")[0].style.display = "none";
    Array.from(document.getElementsByClassName("active-facets-mobile")).forEach(
      (el) => {
        el.style.display = "none";
      },
    );
    (setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    }),
      t.setAttribute("aria-expanded", !0),
      trapFocus(this.mainDetailsToggle, t),
      document.body.classList.add("overflow-hidden-" + this.dataset.breakpoint),
      (document.getElementsByClassName("facets-wrapper")[0].style.zIndex =
        "999"));
    const retailFacetsWrapper = document.getElementsByClassName(
      "retail-facets-wrapper",
    )[0];
    if (retailFacetsWrapper) {
      retailFacetsWrapper.style.zIndex = "999";
      retailFacetsWrapper.querySelectorAll("details").forEach((t) => {
        t.classList.add("menu-opening");
      });
    }
  }
  closeMenuDrawer(t, e = !1) {
    if (void 0 === t) return;
    this.mainDetailsToggle.classList.remove("menu-opening");
    if (!window.matchMedia("(max-width: 990px)").matches) {
      this.mainDetailsToggle.querySelectorAll("details").forEach((t) => {
        (t.removeAttribute("open"), t.classList.remove("menu-opening"));
      });
      this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((t) => {
        t.classList.remove("submenu-open");
      });
    }
    (document.body.classList.remove(
      "overflow-hidden-" + this.dataset.breakpoint,
    ),
      removeTrapFocus(e),
      this.closeAnimation(this.mainDetailsToggle),
      t instanceof KeyboardEvent && e?.setAttribute("aria-expanded", !1));
    const i = document.getElementsByClassName("facets-wrapper");
    i.length > 0 && (i[0].style.zIndex = "2");
    if (document.getElementsByClassName("retail-facets-wrapper")[0]) {
      document.getElementsByClassName("retail-facets-wrapper")[0].style.zIndex =
        "2";
    }
    Array.from(document.getElementsByClassName("active-facets-mobile")).forEach(
      (el) => {
        el.style.display = "flex";
      },
    );
    document.getElementsByTagName("sticky-header")[0].style.display = "block";
    document.getElementsByClassName("utility-bar")[0].style.display = "block";
    document.getElementsByClassName("haptik-icon")[0].style.zIndex = 10;
  }
  onFocusOut() {
    setTimeout(() => {
      this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement) &&
        this.closeMenuDrawer();
    });
  }
  onCloseButtonClick(t) {
    const e = t.currentTarget.closest("details");
    (this.closeSubmenu(e),
      (document.getElementsByClassName("facets-wrapper")[0].style.zIndex = "2"),
      document.body.classList.remove(
        "overflow-hidden-" + this.dataset.breakpoint,
      ));
    if (document.getElementsByClassName("retail-facets-wrapper")[0]) {
      document.getElementsByClassName("retail-facets-wrapper")[0].style.zIndex =
        "2";
    }
    Array.from(document.getElementsByClassName("active-facets-mobile")).forEach(
      (el) => {
        el.style.display = "flex";
      },
    );
    document.getElementsByTagName("sticky-header")[0].style.display = "block";
    document.getElementsByClassName("utility-bar")[0].style.display = "block";
    document.getElementsByClassName("haptik-icon")[0].style.zIndex = 10;
  }
  closeSubmenu(t) {
    const e = t.closest(".submenu-open");
    (e && e.classList.remove("submenu-open"),
      t.classList.remove("menu-opening"),
      t.querySelector("summary").setAttribute("aria-expanded", !1),
      removeTrapFocus(t.querySelector("summary")),
      this.closeAnimation(t));
  }
  closeAnimation(t) {
    let e;
    const i = (s) => {
      (void 0 === e && (e = s),
        s - e < 400
          ? window.requestAnimationFrame(i)
          : (t.removeAttribute("open"),
            t.closest("details[open]") &&
              trapFocus(
                t.closest("details[open]"),
                t.querySelector("summary"),
              )));
    };
    window.requestAnimationFrame(i);
  }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }
  openMenuDrawer(t) {
    Array.from(document.getElementsByClassName("active-facets-mobile")).forEach(
      (el) => {
        el.style.display = "none";
      },
    );
    ((this.header = this.header || document.querySelector(".section-header")),
      (this.borderOffset =
        this.borderOffset ||
        this.closest(".header-wrapper").classList.contains(
          "header-wrapper--border-bottom",
        )
          ? 1
          : 0),
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset,
        ) + "px",
      ),
      this.header.classList.add("menu-open"),
      setTimeout(() => {
        this.mainDetailsToggle.classList.add("menu-opening");
      }),
      t.setAttribute("aria-expanded", !0),
      window.addEventListener("resize", this.onResize),
      trapFocus(this.mainDetailsToggle, t),
      document.body.classList.add(
        "overflow-hidden-" + this.dataset.breakpoint,
      ));
  }
  closeMenuDrawer(t, e) {
    e &&
      (super.closeMenuDrawer(t, e),
      this.header.classList.remove("menu-open"),
      window.removeEventListener("resize", this.onResize));
  }
  onResize = () => {
    (this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset,
        ) + "px",
      ),
      document.documentElement.style.setProperty(
        "--viewport-height",
        window.innerHeight + "px",
      ));
  };
}
customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("keyup", (t) => {
      "ESCAPE" === t.code.toUpperCase() && this.hide();
    });
    this.classList.contains("media-modal")
      ? this.addEventListener("pointerup", (t) => {
          "mouse" !== t.pointerType ||
            t.target.closest("deferred-media, product-model") ||
            this.hide();
        })
      : this.addEventListener("click", (t) => {
          t.target === this && this.hide();
        });
  }
  connectedCallback() {
    if (!this.closeBound) {
      this.closeBound = true;
      const closeButton = this.querySelector('[id^="ModalClose-"]');
      if (closeButton) {
        closeButton.addEventListener("click", this.hide.bind(this, false));
      }
    }
    this.moved || ((this.moved = true), document.body.appendChild(this));
  }
  show(t) {
    this.openedBy = t;
    const e = this.querySelector(".template-popup");
    (document.body.classList.add("overflow-hidden"),
      this.setAttribute("open", ""),
      e && e.loadContent(),
      trapFocus(this, this.querySelector('[role="dialog"]')),
      window.pauseAllMedia());
  }
  hide() {
    (document.body.classList.remove("overflow-hidden"),
      document.body.dispatchEvent(new CustomEvent("modalClosed")),
      this.removeAttribute("open"),
      removeTrapFocus(this.openedBy),
      window.pauseAllMedia());
  }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    if (this.bound) return;
    this.bound = true;
    const t =
      this.querySelector("button") || this.querySelector("#open-prod-modal");
    t &&
      t.addEventListener("click", () => {
        const e = document.querySelector(this.getAttribute("data-modal"));
        e && typeof e.show === "function" && e.show(t);
      });
  }
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const t = this.querySelector('[id^="Deferred-Poster-"]');
    t && t.addEventListener("click", this.loadContent.bind(this));
    this.enable_autoplay = this.querySelector("#autoplay-value")
      ? this.querySelector("#autoplay-value").value
      : null;
    if (this.enable_autoplay) t.click();
  }
  loadContent(t = !0) {
    if (
      (this.enable_autoplay || window.pauseAllMedia(),
      !this.getAttribute("loaded"))
    ) {
      const e = document.createElement("div");
      (e.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(!0),
      ),
        this.setAttribute("loaded", !0));
      const i = this.appendChild(
        e.querySelector("video, model-viewer, iframe"),
      );
      (t && i.focus(),
        "VIDEO" == i.nodeName && i.getAttribute("autoplay") && i.play());
    }
  }
}
customElements.define("deferred-media", DeferredMedia);
class SliderComponent extends HTMLElement {
  constructor() {
    (super(), this.initSlider());
  }
  initSlider() {
    ((this.slider = this.querySelector('[id^="Slider-"]')),
      (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
      (this.enableSliderLooping = !1),
      (this.currentPageElement = this.querySelector(
        ".slider-counter--current",
      )),
      (this.pageTotalElement = this.querySelector(".slider-counter--total")),
      (this.prevButton = this.querySelector('button[name="previous"]')),
      (this.nextButton = this.querySelector('button[name="next"]')),
      this.slider &&
        this.nextButton &&
        !this.hasAttribute("data-gallery-swipe") &&
        (this.initPages(),
        new ResizeObserver((t) => this.initPages()).observe(this.slider),
        this.slider.addEventListener("scroll", this.update.bind(this)),
        this.prevButton.addEventListener(
          "click",
          this.onButtonClick.bind(this),
        ),
        this.nextButton.addEventListener(
          "click",
          this.onButtonClick.bind(this),
        )));
  }
  initPages() {
    ((this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (t) => t.clientWidth > 0,
    )),
      this.sliderItemsToShow.length < 2 ||
        ((this.sliderItemOffset =
          this.sliderItemsToShow[1].offsetLeft -
          this.sliderItemsToShow[0].offsetLeft),
        (this.slidesPerPage = Math.floor(
          (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
            this.sliderItemOffset,
        )),
        (this.totalPages =
          this.sliderItemsToShow.length - this.slidesPerPage + 1),
        this.update()));
  }
  resetPages() {
    ((this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
      this.initPages());
  }
  update() {
    if (!this.slider || !this.nextButton) return;
    const t = this.currentPage;
    ((this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1),
      this.currentPageElement &&
        this.pageTotalElement &&
        ((this.currentPageElement.textContent = this.currentPage),
        (this.pageTotalElement.textContent = this.totalPages)),
      this.currentPage != t &&
        this.dispatchEvent(
          new CustomEvent("slideChanged", {
            detail: {
              currentPage: this.currentPage,
              currentElement: this.sliderItemsToShow[this.currentPage - 1],
            },
          }),
        ),
      this.enableSliderLooping ||
        (this.isSlideVisible(this.sliderItemsToShow[0]) &&
        0 === this.slider.scrollLeft
          ? this.prevButton.setAttribute("disabled", "disabled")
          : this.prevButton.removeAttribute("disabled"),
        this.isSlideVisible(
          this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
        )
          ? this.nextButton.setAttribute("disabled", "disabled")
          : this.nextButton.removeAttribute("disabled")));
  }
  isSlideVisible(t, e = 0) {
    if (t) {
      const i = this.slider.clientWidth + this.slider.scrollLeft - e;
      return (
        t.offsetLeft + t.clientWidth <= i &&
        t.offsetLeft >= this.slider.scrollLeft
      );
    }
  }
  onButtonClick(t) {
    t.preventDefault();
    const e = t.currentTarget.dataset.step || 1;
    ((this.slideScrollPosition =
      "next" === t.currentTarget.name
        ? this.slider.scrollLeft + e * this.sliderItemOffset
        : this.slider.scrollLeft - e * this.sliderItemOffset),
      this.setSlidePosition(this.slideScrollPosition));
  }
  setSlidePosition(t) {
    this.slider.scrollTo({ left: t });
  }
}
customElements.define("slider-component", SliderComponent);
class SlideshowComponent extends SliderComponent {
  constructor() {
    (super(),
      (this.sliderControlWrapper = this.querySelector(".slider-buttons")),
      (this.enableSliderLooping = !0),
      this.sliderControlWrapper &&
        ((this.sliderFirstItemNode =
          this.slider.querySelector(".slideshow__slide")),
        this.sliderItemsToShow.length > 0 && (this.currentPage = 1),
        (this.announcementBarSlider = this.querySelector(
          ".announcement-bar-slider",
        )),
        (this.announcerBarAnimationDelay = this.announcementBarSlider
          ? 250
          : 0),
        (this.sliderControlLinksArray = Array.from(
          this.sliderControlWrapper.querySelectorAll(".slider-counter__link"),
        )),
        this.sliderControlLinksArray.forEach((t) =>
          t.addEventListener("click", this.linkToSlide.bind(this)),
        ),
        this.slider.addEventListener(
          "scroll",
          this.setSlideVisibility.bind(this),
        ),
        this.setSlideVisibility(),
        this.announcementBarSlider &&
          ((this.announcementBarArrowButtonWasClicked = !1),
          (this.reducedMotion = window.matchMedia(
            "(prefers-reduced-motion: reduce)",
          )),
          this.reducedMotion.addEventListener("change", () => {
            "true" === this.slider.getAttribute("data-autoplay") &&
              this.setAutoPlay();
          }),
          [this.prevButton, this.nextButton].forEach((t) => {
            t.addEventListener(
              "click",
              () => {
                this.announcementBarArrowButtonWasClicked = !0;
              },
              { once: !0 },
            );
          })),
        "true" === this.slider.getAttribute("data-autoplay") &&
          this.setAutoPlay()));
  }
  setAutoPlay() {
    ((this.autoplaySpeed = 1e3 * this.slider.dataset.speed),
      this.addEventListener("mouseover", this.focusInHandling.bind(this)),
      this.addEventListener("mouseleave", this.focusOutHandling.bind(this)),
      this.addEventListener("focusin", this.focusInHandling.bind(this)),
      this.addEventListener("focusout", this.focusOutHandling.bind(this)),
      this.querySelector(".slideshow__autoplay")
        ? ((this.sliderAutoplayButton = this.querySelector(
            ".slideshow__autoplay",
          )),
          this.sliderAutoplayButton.addEventListener(
            "click",
            this.autoPlayToggle.bind(this),
          ),
          (this.autoplayButtonIsSetToPlay = !0),
          this.play())
        : this.reducedMotion.matches ||
            this.announcementBarArrowButtonWasClicked
          ? this.pause()
          : this.play());
  }
  onButtonClick(t) {
    (super.onButtonClick(t), (this.wasClicked = !0));
    const e = 1 === this.currentPage,
      i = this.currentPage === this.sliderItemsToShow.length;
    e || i
      ? (e && "previous" === t.currentTarget.name
          ? (this.slideScrollPosition =
              this.slider.scrollLeft +
              this.sliderFirstItemNode.clientWidth *
                this.sliderItemsToShow.length)
          : i &&
            "next" === t.currentTarget.name &&
            (this.slideScrollPosition = 0),
        this.setSlidePosition(this.slideScrollPosition),
        this.applyAnimationToAnnouncementBar(t.currentTarget.name))
      : this.applyAnimationToAnnouncementBar(t.currentTarget.name);
  }
  setSlidePosition(t) {
    (this.setPositionTimeout && clearTimeout(this.setPositionTimeout),
      (this.setPositionTimeout = setTimeout(() => {
        this.slider.scrollTo({ left: t });
      }, this.announcerBarAnimationDelay)));
  }
  update() {
    (super.update(),
      (this.sliderControlButtons = this.querySelectorAll(
        ".slider-counter__link",
      )),
      this.prevButton.removeAttribute("disabled"),
      this.sliderControlButtons.length &&
        (this.sliderControlButtons.forEach((t) => {
          (t.classList.remove("slider-counter__link--active"),
            t.removeAttribute("aria-current"));
        }),
        this.sliderControlButtons[this.currentPage - 1] &&
          this.sliderControlButtons[this.currentPage - 1].classList.add(
            "slider-counter__link--active",
          ),
        this.sliderControlButtons[this.currentPage - 1] &&
          this.sliderControlButtons[this.currentPage - 1].setAttribute(
            "aria-current",
            !0,
          )));
  }
  autoPlayToggle() {
    (this.togglePlayButtonState(this.autoplayButtonIsSetToPlay),
      this.autoplayButtonIsSetToPlay ? this.pause() : this.play(),
      (this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay));
  }
  focusOutHandling(t) {
    if (this.sliderAutoplayButton) {
      const e =
        t.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(t.target);
      if (!this.autoplayButtonIsSetToPlay || e) return;
      this.play();
    } else
      this.reducedMotion.matches ||
        this.announcementBarArrowButtonWasClicked ||
        this.play();
  }
  focusInHandling(t) {
    this.sliderAutoplayButton
      ? (t.target === this.sliderAutoplayButton ||
          this.sliderAutoplayButton.contains(t.target)) &&
        this.autoplayButtonIsSetToPlay
        ? this.play()
        : this.autoplayButtonIsSetToPlay && this.pause()
      : this.announcementBarSlider.contains(t.target) && this.pause();
  }
  play() {
    (this.slider.setAttribute("aria-live", "off"),
      clearInterval(this.autoplay),
      (this.autoplay = setInterval(
        this.autoRotateSlides.bind(this),
        this.autoplaySpeed,
      )));
  }
  pause() {
    (this.slider.setAttribute("aria-live", "polite"),
      clearInterval(this.autoplay));
  }
  togglePlayButtonState(t) {
    t
      ? (this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused"),
        this.sliderAutoplayButton.setAttribute(
          "aria-label",
          window.accessibilityStrings.playSlideshow,
        ))
      : (this.sliderAutoplayButton.classList.remove(
          "slideshow__autoplay--paused",
        ),
        this.sliderAutoplayButton.setAttribute(
          "aria-label",
          window.accessibilityStrings.pauseSlideshow,
        ));
  }
  autoRotateSlides() {
    const t =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;
    (this.setSlidePosition(t), this.applyAnimationToAnnouncementBar());
  }
  setSlideVisibility(t) {
    (this.sliderItemsToShow.forEach((t, e) => {
      const i = t.querySelectorAll("a");
      e === this.currentPage - 1
        ? (i.length &&
            i.forEach((t) => {
              t.removeAttribute("tabindex");
            }),
          t.setAttribute("aria-hidden", "false"),
          t.removeAttribute("tabindex"))
        : (i.length &&
            i.forEach((t) => {
              t.setAttribute("tabindex", "-1");
            }),
          t.setAttribute("aria-hidden", "true"),
          t.setAttribute("tabindex", "-1"));
    }),
      (this.wasClicked = !1));
  }
  applyAnimationToAnnouncementBar(t = "next") {
    if (!this.announcementBarSlider) return;
    const e = this.sliderItems.length,
      i = "next" === t ? 1 : -1,
      s = this.currentPage - 1;
    let n = (s + i) % e;
    n = -1 === n ? e - 1 : n;
    const r = this.sliderItems[n],
      o = this.sliderItems[s],
      a = "announcement-bar-slider--fade-in",
      l = "announcement-bar-slider--fade-out",
      d =
        ("next" === t && s !== e - 1) || ("previous" === t && 0 === s)
          ? "next"
          : "previous";
    (o.classList.add(`${l}-${d}`),
      r.classList.add(`${a}-${d}`),
      setTimeout(() => {
        (o.classList.remove(`${l}-${d}`), r.classList.remove(`${a}-${d}`));
      }, 2 * this.announcerBarAnimationDelay));
  }
  linkToSlide(t) {
    t.preventDefault();
    const e =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(t.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({ left: e });
  }
}
customElements.define("slideshow-component", SlideshowComponent);
class VariantSelects extends HTMLElement {
  constructor() {
    (super(), this.addEventListener("change", this.onVariantChange));
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(!0, "", !1);
    this.toggeBuyButton(!0, "", !1);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    if (this.currentVariant) {
      try {
        this.updateMedia();
      } catch (error) {
        console.error(error);
      }
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    } else {
      this.toggleAddButton(!0, "", !0);
      this.setUnavailable();
    }
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll("select"), (t) => t.value);
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(
      (t) => !t.options.map((t, e) => this.options[e] === t).includes(!1),
    );
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const galleryId = this.dataset.productId || this.dataset.section;
    document
      .querySelectorAll(`[id^="MediaGallery-${galleryId}"]`)
      .forEach((t) => {
        if (typeof t.setActiveMedia !== "function") return;
        t.setActiveMedia(
          `${galleryId}-${this.currentVariant.featured_media.id}`,
          !0,
        );
      });
    const t = document.querySelector(
      `#ProductModal-${galleryId} .product-media-modal__content`,
    );
    if (!t) return;
    const e = t.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`,
    );
    if (e) t.prepend(e);
  }
  updateURL() {
    this.currentVariant &&
      "false" !== this.dataset.updateUrl &&
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`,
      );
  }
  updateShareUrl() {
    const t = document.getElementById("Share-" + this.dataset.section);
    t &&
      t.updateUrl &&
      t.updateUrl(
        `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
      );
  }
  updateVariantInput() {
    document
      .querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
      )
      .forEach((t) => {
        const e = t.querySelector('input[name="id"]');
        ((e.value = this.currentVariant.id),
          e.dispatchEvent(new Event("change", { bubbles: !0 })));
      });
  }
  updateVariantStatuses() {
    const t = this.variantData.filter(
        (t) => this.querySelector(":checked").value === t.option1,
      ),
      e = [...this.querySelectorAll(".product-form__input")];
    e.forEach((i, s) => {
      if (0 === s) return;
      const n = [...i.querySelectorAll('input[type="radio"], option')],
        r = e[s - 1].querySelector(":checked").value,
        o = t
          .filter((t) => t.available && t["option" + s] === r)
          .map((t) => t["option" + (s + 1)]);
      this.setInputAvailability(n, o);
    });
  }
  setInputAvailability(t, e) {
    t.forEach((t) => {
      e.includes(t.getAttribute("value"))
        ? (t.innerText = t.getAttribute("value"))
        : (t.innerText = window.variantStrings.unavailable_with_option.replace(
            "[value]",
            t.getAttribute("value"),
          ));
    });
  }
  updatePickupAvailability() {
    const t = document.querySelector("pickup-availability");
    t &&
      (this.currentVariant && this.currentVariant.available
        ? t.fetchAvailability(this.currentVariant.id)
        : (t.removeAttribute("available"), (t.innerHTML = "")));
  }
  removeErrorMessage() {
    const t = this.closest("section");
    if (!t) return;
    const e = t.querySelector("product-form");
    e && e.handleErrorMessage();
  }
  renderProductInfo() {
    const t = this.currentVariant.id,
      e = this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section;
    fetch(
      `${this.dataset.url}?variant=${t}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`,
    )
      .then((t) => t.text())
      .then(async (i) => {
        if (this.currentVariant.id !== t) return;
        const isQuickAddModal = Boolean(this.closest("quick-add-modal"));
        if (
          !isQuickAddModal &&
          (this.currentVariant.name.includes("Anklet") ||
            this.currentVariant.name.includes("Stud For Him") ||
            this.currentVariant.name.includes("Stud For Men"))
        ) {
          if (window.bestPriceCouponPromise) {
            try {
              await window.bestPriceCouponPromise;
            } catch (e) {
              // Coupon fetch failed - fall through and render with whatever's available.
            }
          }
          let code = "";
          let prodPriority = 0;
          let prodText = "";
          let prodDiscount = 0;
          const prodCollections = Array.isArray(window.prodCollection)
            ? window.prodCollection
            : [];
          const rawCoupons =
            typeof bestPriceCouponRes !== "undefined" && Array.isArray(bestPriceCouponRes)
              ? bestPriceCouponRes
              : [];
          const collections = rawCoupons.filter((item) =>
            prodCollections.includes(item.collectionId)
          );
          collections.forEach((item) => {
            if (this.currentVariant.price / 100 >= item.minimumVal) {
              if (
                this.currentVariant.price / 100 <= item.maximumVal ||
                item.maximumVal == 0
              ) {
                if (code == "" || item.priority > prodPriority) {
                  code = item.code;
                  prodText = item.pdpText;
                  prodPriority = item.priority;
                  prodDiscount =
                    item.discountType == "percentage"
                      ? this.currentVariant.price / 100 -
                        (this.currentVariant.price / 100) *
                          (item.discountValue / 100)
                      : this.currentVariant.price / 100 - item.discountValue;
                }
              }
            }
          });
          const bestPriceBox = document.getElementById("best-price-main-box");
          if (bestPriceBox) {
            if (prodText.length > 0) {
              if (prodText.includes("{price}")) {
                bestPriceBox.innerHTML = `${prodText.split("{price}")[0]}<span id="best-price-main">₹${parseInt(prodDiscount).toLocaleString("en-US")}</span>${prodText.split("{price}")[1].split("{coupon}")[0]}<span id="best-price-coupon">${code}</span>`;
              } else {
                bestPriceBox.innerHTML = `<span id="best-price-main">${prodText.split("{coupon}")[0]}</span> <span id="best-price-coupon">${code}</span>`;
              }
            } else {
              bestPriceBox.innerHTML = "";
            }
          }
          if (
            window.matchMedia("(max-width: 750px)").matches &&
            typeof setContainerHeight === "function"
          ) {
            setContainerHeight("true");
          }
        }
        const s = new DOMParser().parseFromString(i, "text/html"),
          n = document.getElementById("price-" + this.dataset.section),
          r = s.getElementById(
            "price-" +
              (this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section),
          ),
          o = s.getElementById(
            "Sku-" +
              (this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section),
          ),
          a = document.getElementById("Sku-" + this.dataset.section),
          l = s.getElementById(
            "Inventory-" +
              (this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section),
          ),
          d = document.getElementById("Inventory-" + this.dataset.section),
          u = s.getElementById(
            "Volume-" +
              (this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section),
          ),
          c = document.getElementById("Price-Per-Item-" + this.dataset.section),
          h = s.getElementById(
            "Price-Per-Item-" +
              (this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section),
          ),
          m = document.getElementById("Volume-" + this.dataset.section);
        (r && n && (n.innerHTML = r.innerHTML),
          l && d && (d.innerHTML = l.innerHTML),
          o &&
            a &&
            ((a.innerHTML = o.innerHTML),
            a.classList.toggle(
              "visibility-hidden",
              o.classList.contains("visibility-hidden"),
            )),
          u && m && (m.innerHTML = u.innerHTML),
          h &&
            c &&
            ((c.innerHTML = h.innerHTML),
            c.classList.toggle(
              "visibility-hidden",
              h.classList.contains("visibility-hidden"),
            )));
        const p = document.getElementById("price-" + this.dataset.section);
        (p && p.classList.remove("visibility-hidden"),
          d &&
            l &&
            d.classList.toggle("visibility-hidden", "" === l.innerText));
        const y = s.getElementById("ProductSubmitButton-" + e),
          g = s.getElementById("ProductBuyButton-" + e);
        const shouldDisableAdd = y
          ? y.hasAttribute("disabled")
          : !this.currentVariant.available;
        const shouldDisableBuy = g
          ? g.hasAttribute("disabled") || g.style.display === "none"
          : !this.currentVariant.available;
        (this.toggleAddButton(
          shouldDisableAdd,
          shouldDisableAdd ? window.variantStrings.soldOut : "",
        ),
          this.toggeBuyButton(
            shouldDisableBuy,
            shouldDisableBuy ? window.variantStrings.soldOut : "",
          ),
          publish(PUB_SUB_EVENTS.variantChange, {
            data: { sectionId: e, html: s, variant: this.currentVariant },
          }));
      })
      .catch((error) => {
        console.error(error);
        if (!this.currentVariant) return;
        this.toggleAddButton(
          !this.currentVariant.available,
          this.currentVariant.available ? "" : window.variantStrings.soldOut,
        );
        this.toggeBuyButton(
          !this.currentVariant.available,
          this.currentVariant.available ? "" : window.variantStrings.soldOut,
        );
      });
  }
  toggleAddButton(t = !0, e) {
    const i = document.getElementById("product-form-" + this.dataset.section);
    if (!i) return;
    const s = i.querySelector('[name="add"]'),
      n = i.querySelector('[name="add"] > span');
    if (!s) return;
    if (t) {
      s.setAttribute("disabled", "disabled");
      if (e && n) n.textContent = e;
    } else {
      s.removeAttribute("disabled");
      if (n && !n.querySelector("svg")) {
        n.textContent = window.variantStrings.addToCart;
      }
    }
  }
  toggeBuyButton(t = !0, e) {
    const i = document.getElementById("product-form-" + this.dataset.section);
    if (!i) return;
    const s = i.querySelector('[name="buy"]'),
      n = i.querySelector('[name="buy"] > span');
    if (!s) return;
    if (t) {
      s.setAttribute("disabled", "disabled");
      if (e && n) n.textContent = e;
    } else {
      s.removeAttribute("disabled");
      if (n && !n.querySelector("svg")) {
        n.textContent = window.variantStrings.buyNow;
      }
    }
  }
  setUnavailable() {
    const t = document.getElementById("product-form-" + this.dataset.section),
      e = t.querySelector('[name="add"]'),
      i = t.querySelector('[name="add"] > span'),
      s = document.getElementById("price-" + this.dataset.section),
      n = document.getElementById("Inventory-" + this.dataset.section),
      r = document.getElementById("Sku-" + this.dataset.section),
      o = document.getElementById("Price-Per-Item-" + this.dataset.section);
    e &&
      ((i.textContent = window.variantStrings.unavailable),
      s && s.classList.add("visibility-hidden"),
      n && n.classList.add("visibility-hidden"),
      r && r.classList.add("visibility-hidden"),
      o && o.classList.add("visibility-hidden"));
  }
  getVariantData() {
    return (
      (this.variantData =
        this.variantData ||
        JSON.parse(
          this.querySelector('[type="application/json"]').textContent,
        )),
      this.variantData
    );
  }
}
customElements.define("variant-selects", VariantSelects);
class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }
  setInputAvailability(t, e) {
    t.forEach((t) => {
      e.includes(t.getAttribute("value"))
        ? t.classList.remove("disabled")
        : t.classList.add("disabled");
    });
  }
  updateOptions() {
    const t = Array.from(this.querySelectorAll("fieldset"));
    this.options = t.map(
      (t) =>
        Array.from(t.querySelectorAll("input")).find((t) => t.checked).value,
    );
  }
}
customElements.define("variant-radios", VariantRadios);
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    new IntersectionObserver(
      ((t, e) => {
        t[0].isIntersecting &&
          (e.unobserve(this),
          fetch(this.dataset.url)
            .then((t) => t.text())
            .then((t) => {
              const e = document.createElement("div");
              e.innerHTML = t;
              const i = e.querySelector("product-recommendations");
              (i && i.innerHTML.trim().length && (this.innerHTML = i.innerHTML),
                !this.querySelector("slideshow-component") &&
                  this.classList.contains("complementary-products") &&
                  this.remove(),
                e.querySelector(".grid__item") &&
                  this.classList.add("product-recommendations--loaded"));
            })
            .catch((t) => {
              console.error(t);
            }));
      }).bind(this),
      { rootMargin: "0px 0px 400px 0px" },
    ).observe(this);
  }
}
customElements.define("product-recommendations", ProductRecommendations);

window.addEventListener("pageshow", async function (event) {
  if (event.persisted) {
    document
      .querySelector(".cart-notification-overlay.active")
      ?.classList.remove("active");
  }
  async function waitForShowCustomCart() {
    while (!localStorage.getItem("showCustomCart")) {
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
    return localStorage.getItem("showCustomCart");
  }
  const showCustomCart = await waitForShowCustomCart();
  if (showCustomCart == "true") {
    cartHomePromise = null;
    cartCountPromise = null;
    setCartItemCount();
  }
});
